/**
 * Custom hook to access Office.js context
 * Must be used within an OfficeProvider
 */
import { useContext } from 'react';

import { OfficeContext } from './OfficeContext';

export function useOffice() {
  const context = useContext(OfficeContext);
  if (context === undefined) {
    throw new Error('useOffice must be used within an OfficeProvider');
  }
  return context;
}
